import { render, staticRenderFns } from "./ProspectSetup.vue?vue&type=template&id=56113d0c&scoped=true&"
import script from "./ProspectSetup.vue?vue&type=script&lang=js&"
export * from "./ProspectSetup.vue?vue&type=script&lang=js&"
import style0 from "./ProspectSetup.vue?vue&type=style&index=0&id=56113d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56113d0c",
  null
  
)

export default component.exports